import React from 'react';
import { cn } from '@bem-react/classname';
import './Content.css';
export var cnUserID = cn('UserWidget', 'Content');
export var Content = React.forwardRef(function (props, ref) {
    var loading = props.loading, preload = props.preload, height = props.height, colorScheme = props.colorScheme, src = props.src, width = props.width;
    return (React.createElement("div", { className: cnUserID({ loading: loading, colorScheme: colorScheme }) },
        preload && (React.createElement("iframe", { className: "UserWidget-Iframe", ref: ref, width: width, src: src, height: loading ? 300 : height })),
        loading && React.createElement("div", { className: "UserWidget-Spin" })));
});
